import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

const translationSlice = createSlice({
    name: 'translation',

    initialState: {
        sidebarFilters: {
            showDisabledForTranslation: true,
            variantId: 0,
            showUnverified: true,
            showVerified: true,
            showComplete: true,
            sourceChangesMarked: true,
            entity: {},
            search: '',
            reimbursement: null,
        },
        contentFilters: {
            showDisabledForTranslation: true,
            showUntranslated: true,
            showUnverified: true,
            showVerified: true,
            showComplete: true,
        },
        selectedEntities: {},
        expandedEntities: {},
    },

    reducers: {
        resetFilters: {
            reducer(state, action) {
                const initialState = translationSlice.getInitialState();
                state.sidebarFilters = initialState.sidebarFilters;
                state.contentFilters = initialState.contentFilters;
            },
        },
        setFilter: {
            reducer(state, action) {
                const { key, value } = action.payload;
                state.sidebarFilters[key] = value;
            },
        },
        setContentFilter: {
            reducer(state, action) {
                const { key, value } = action.payload;
                if (state.contentFilters.hasOwnProperty(key)) {
                    state.contentFilters[key] = value;
                }
            },
        },
        resetContentFilters: {
            reducer(state) {
                state.contentFilters = translationSlice.getInitialState().contentFilters;
            },
        },
        setExpandedEntity: {
            reducer(state, action) {
                const { translationLanguage, activeKey, view = 'default' } = action.payload;
                _.set(state.expandedEntities, `[${translationLanguage}.${view}]`, activeKey);
            },
        },
    },

    extraReducers: (builder) => {
        builder.addCase('security/resetState', (state) => {
            Object.assign(state, translationSlice.getInitialState());
        });
    },
});

export const { resetFilters, setFilter, setContentFilter, resetContentFilters, setExpandedEntity } = translationSlice.actions;

export const getDefaultActiveKey = (translationLanguageId, view = 'default') => (state) =>
    _.get(state.translation.expandedEntities, `[${translationLanguageId}.${view}]`);

export default translationSlice.reducer;
